/* istanbul ignore file */
import { BooleanField, DateField, FullDateField, NumberField } from 'framework/ui/field';
import { EmployeeLinkField } from 'domain/shared/employee';
import { BudgetLinkField } from 'domain/shared/budget';
import EditBudgetButton from 'domain/finance/budget/List/button/EditBudgetButton';
import { CREATE_BUDGET, UPDATE_BUDGET } from 'domain/shared/budget';
import BudgetSearchLinkField from '../shared/BudgetSearchLinkField';
import ArchiveBudgetButton from 'domain/finance/budget/List/button/ArchiveBudgetButton';
import CopyBudgetForNextYearButton from 'domain/finance/budget/List/button/CopyBudgetForNextYearButton';
import { DataGridLayout, TableBodyWithGrouping } from 'framework/list';

const BudgetListLayout = () => {
  return (
    <DataGridLayout
      tableWrapperClassName="budget-list"
      buttons={[
        <EditBudgetButton key="edit-budget" source="id" outline permissionToCheck={UPDATE_BUDGET} />,
        <ArchiveBudgetButton
          key="archive-budget"
          source="id"
          nameSource="name"
          valueSource="archived"
          permissionToCheck={UPDATE_BUDGET}
        />,
        <CopyBudgetForNextYearButton
          source="id"
          nameSource="name"
          permissionToCheck={CREATE_BUDGET}
          isVisible={(data: any) => !!data.periodFrom}
        />,
      ]}
      tableBodyComponent={(props: any) => (
        <TableBodyWithGrouping {...props} childrenSource="childBudgets" toggleSource="name" />
      )}
    >
      <BudgetLinkField label="ID" source="id" nameSource="id" isSortable width={70} />
      <BudgetSearchLinkField source="name" idSource="id" label="Name" width={250} isSortable />
      <EmployeeLinkField
        source="ownerId"
        sortSource="ownerNameEn"
        nameSource="ownerName"
        label="Owner"
        width={150}
        isSortable
      />
      <DateField source="periodFrom" label="Start Date" isSortable width={130} />
      <DateField source="softPeriodFrom" label="Soft Start Date" isSortable width={130} />
      <DateField source="softPeriodTo" label="Soft End Date" isSortable width={130} />
      <DateField source="periodTo" label="End Date" isSortable width={130} />
      <NumberField source="maxFtePercent" label="Max FTE, people" width={100} displayZeroValue={false} />
      <BooleanField source="archived" label="Archived" width={80} />
      <FullDateField source="updatedAt" label="Last Modified Date" isSortable width={160} />
    </DataGridLayout>
  );
};

export default BudgetListLayout;
